import { DROP_D_TUNING, STANDARD_TUNING, type Tuning } from './fretboard';

                                                                           

export function getTuning(id: string): Tuning {
  return TUNINGS.find((t) => t.id === id) ?? STANDARD_TUNING;
}

import { TUNINGS } from "/Users/pookey/Documents/personal/Projects.nosync.noindex/guitar.nosync/app/src/theory/tunings.ts?split=0";
